// @flow
import { createContext } from 'react';

export const StreamGovernanceContext = createContext({});
